import LatestCatalogObject from '@square/dashboard-items-data/adapters/connect/latest-catalog-object';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { MULTIPLE_IMAGES_API_VERSION as SUBSCRIPTION_PLAN_API_VERSION } from '@square/dashboard-items-data/adapters/connect/image';
import { SUBSCRIPTION_ITEMIZATION_API_VERSION } from '@square/dashboard-items-data/models/connect/subscription-plan';
export default LatestCatalogObject.extend({
  features: service(),
  itemizationStatus: service('buyer-subs/itemization-status'),
  shouldBackgroundReloadRecord(store, snapshot) {
    return snapshot?.id?.[0] !== '#';
  },
  headers: computed('itemizationStatus.isItemized', function () {
    if (this.itemizationStatus.isItemized || this.features.isEnabled('buyersubs/updated_legacy_api_version')) {
      return {
        'Square-Version': SUBSCRIPTION_ITEMIZATION_API_VERSION
      };
    } else {
      return {
        'Square-Version': SUBSCRIPTION_PLAN_API_VERSION
      };
    }
  })
});